import React from "react";
import styled from "styled-components";
import { PlatFormAudioTrackTitleProps } from "../types";
import WaveformPlayer from "./PlatFormWaveformPlayer";
import Play from "assets/playBlue.svg";
import Pause from "assets/pause.png";
import { ProgressSpinner } from "primereact/progressspinner";



const PlatFormAudioTrackTitle: React.FC<PlatFormAudioTrackTitleProps> = ({
  index,
  title,
  artists,
  audio,
  id
}) => {

  const audioUrl = audio?.find((val) => val.id === id.toString())?.audio;
  const waveformRef = React.useRef<any>(null);
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);

  return (
    <TrackContainer>
      <LeftSection>
        <Index>
          {String(index).padStart(2, '0')}
          <PlayButton
            aria-disabled={!audioUrl || !isReady}
            onMouseDown={(e) => {
              // Prevent accordion toggle when clicking play
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!audioUrl || !isReady) return;
              waveformRef.current?.togglePlay?.();
            }}
          >
            {!audioUrl || !isReady ? (
              <SpinnerWrap>
                <ProgressSpinner style={{ width: 20, height: 20 }} strokeWidth="6" />
              </SpinnerWrap>
            ) : isPlaying ? (
              <img src={Pause} alt="pause" width={20} height={20} />
            ) : (
              <Play />
            )}
          </PlayButton>
        </Index>
        <TextContent>
          <TrackTitle>{title}</TrackTitle>
          <ArtistNames>{artists}</ArtistNames>
        </TextContent>
      </LeftSection>
      <RightSection
        onMouseDown={(e) => {
          // Prevent accordion toggle when interacting with waveform
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {audioUrl && (
          <WaveformPlayer
            ref={waveformRef}
            id={id}
            audio={audio}
            active={false}
            time
            onPlayStateChange={setIsPlaying}
            onReadyChange={setIsReady}
          />
        )}
      </RightSection>
    </TrackContainer>
  );
};
const TrackContainer = styled.div`
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 25px;
  padding-right: 18px;
`;

const LeftSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Index = styled.span`
  display: flex;
  align-items: center;
  gap: 11px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
`;

const PlayButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const SpinnerWrap = styled.span`
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const TrackTitle = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
`;

const ArtistNames = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  color: #00000080;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;


export default PlatFormAudioTrackTitle;
